/* eslint-disable @typescript-eslint/no-explicit-any */
import { FeatureConfigState } from '@/models/store'

const getConfig =
  (state: FeatureConfigState) =>
  ({ name, key }: { name: string; key: string }) => {
    if (name)
      return state.configs.find(
        (c: { name: string; key: string }) => c.name === name
      )
    if (key)
      return state.configs.find(
        (c: { name: string; key: string }) => c.key === key
      )
  }

const isVisibleByUserIdRole =
  (_: FeatureConfigState, getters: any) =>
  ({ name, userIdRole }: { name: string; userIdRole: string }) => {
    const config = getters.getConfig({ name })
    if (!config?.active) return false
    if (config.public) return true
    if (Array.isArray(userIdRole)) {
      return !!userIdRole.find(item => config.value.includes(item))
    }
    return config.value.includes(userIdRole)
  }

export default {
  isVisibleByUserIdRole,
  getConfig
}
